import Pill from "../common/Pill"

interface Props {
    label: string;
    onClick: any;
    cursor:boolean
}

function SubscribeButton(props: Props) {
    const { label,cursor,onClick } = props
    let containerClasses='bg-yellow'
    containerClasses += cursor ? ' cursor-pointer' : ''

    return (
        <Pill
            onClick = {onClick}
            containerClasses={containerClasses}
            typographyStyles={{ color: 'black', fontSize: 16, padding: '12px' }}>
            {label}
        </Pill>
    )
}

export default SubscribeButton